<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div style="text-align: center; width: 100% !important; padding: 65px;"
      v-if="this.$store.getters.localUserSubscription !== null
        && this.$store.getters.localUserSubscription.type === 'asyougo'" v-html="$t('appSettings.integrations.onlyAvailable')">
    </div>
    <div v-if="!this.$store.getters.isLoading
      && this.$store.getters.localUserSubscription !== null
      && this.$store.getters.localUserSubscription.type !== 'asyougo'" class="flex xs12">
      <va-card :title="$t('appSettings.integrations.title')">
        <template slot="actions">
          <va-button icon="fa fa-plus" @click.prevent="createIntegration()" />
        </template>
        <div class="va-card__body" v-if="appSettings.length < 1">
          <va-notification v-if="appSettings.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('appSettings.integrations.badgeText') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading && appSettings.length > 0 && this.$store.getters.localUserSubscription !== null
      && this.$store.getters.localUserSubscription.type !== 'asyougo'" class="flex xs12">
      <va-card stripe="primary">
        <va-list fit class="mb-2">
          <va-item v-for="(element, index) in appSettings" :key="element.app3rdPartyId">
            <va-item-section side>
              {{element.app3rdPartyType.name}}
            </va-item-section>
            <va-item-section>
              <va-item-label>
                {{get3rdPartyDescription(element.app3rdPartyType.name)}}
              </va-item-label>
              <va-item-label caption>
                {{get3rdPartyTitle(element.app3rdPartyType.name)}}
              </va-item-label>
            </va-item-section>
            <va-item-section side>
              <va-button-group>
                <va-button flat small color="gray" @click="updateIntegration(element, index)" icon-right="fa fa-edit"> {{ $t('appSettings.integrations.btnEdit') }}</va-button>
                <va-button flat small color="gray" @click="showPromptModal(element.app3rdPartyId, index)" icon-right="fa fa-trash"> {{ $t('appSettings.integrations.btnRemove') }}</va-button>
              </va-button-group>
            </va-item-section>
          </va-item>
        </va-list>
      </va-card>
    </div>

    <va-modal
      v-model="modalState"
      :title="$t('appSettings.integrations.modalTitle')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <SwappingSquaresSpinner v-if="modalLoader"
        :animation-duration="1000"
        :size="90"
        :color="this.$store.getters.config.palette.primary"
        style="margin: 30px auto;"
      />
      <form v-if="!modalLoader">
        <div class="row">
          <div class="flex md12 xs12">
            <va-select
              :disabled="isUpdate"
              :label="$t('appSettings.integrations.selectType')"
              v-model="app3rdPartyType"
              textBy="name"
              keyBy="app3rdPartyTypeId"
              :options="app3rdPartyTypes"
              :error="!!appThirdPartyTypeError.length"
            />
          </div>
          <div class="flex md12 xs12">
            <va-input
              v-model="appSetting.secretKey"
              type="text-area"
              :label="$t('appSettings.integrations.secretKey')"
              :error="!!secretKeyError.length"
              :error-messages="secretKeyError"
            />
          </div>
          <div class="flex md12 xs12">
            <va-input
              v-model="appSetting.apiKey"
              type="text-area"
              :label="$t('appSettings.integrations.apiKey')"
              class="flex xs12"
              :error="!!apiKeyError.length"
              :error-messages="apiKeyError"
            />
          </div>
          <div class="flex md12 xs12">
            <va-input
              v-model="appSetting.infoKey"
              type="text-area"
              :label="$t('appSettings.integrations.infoKey')"
              class="flex xs12"
            />
          </div>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('appSettings.integrations.btnClose') }}</va-button>
          <va-button @click.prevent="onsubmit()" class="my-0">{{isUpdate ? $t('appSettings.integrations.btnUpdate') : $t('appSettings.integrations.btnCreate')}}</va-button>
        </div>
      </form>
    </va-modal>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('appSettings.integrations.deleteModalTitle')"
      :message="$t('appSettings.integrations.deleteModalMessage')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('appSettings.integrations.modalNo') }}</va-button>
        <va-button type="submit" @click="removeIntegration(app3rdPartyIdInPrompt, indexInPrompt)" class="my-0">{{ $t('appSettings.integrations.modalYes') }}</va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'AppThirdPartySettings',
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  data () {
    return {
      appSettings: [],
      appSetting: {
        app3rdPartyTypeId: 0,
        secretKey: '',
        apiKey: '',
        infoKey: '',
      },
      appThirdPartyTypeError: [],
      secretKeyError: [],
      apiKeyError: [],
      app3rdPartyTypes: [],
      app3rdPartyType: {},
      modalLoader: false,
      modalState: false,
      disabledDelete: false,
      isUpdate: false,
      showRemoveModal: false,
      indexInPrompt: null,
      app3rdPartyIdInPrompt: null,
    }
  },
  methods: {
    async disableModal () {
      this.modalState = false
      this.modalLoader = false
      this.isUpdate = false
      this.appSetting.app3rdPartyTypeId = 0
      this.appSetting.secretKey = ''
      this.appSetting.apiKey = ''
      this.app3rdPartyType = {}
    },
    async onsubmit () {
      this.secretKeyError = this.appSetting.secretKey ? [] : [this.$t('appSettings.integrations.secretKeyError')]
      this.apiKeyError = this.appSetting.apiKey ? [] : [this.$t('appSettings.integrations.apiKeyError')]
      this.appThirdPartyTypeError = this.app3rdPartyType ? [] : [this.$t('appSettings.integrations.appThirdPartyTypeError')]
      if (!this.formConfigurationReady) {
        return
      }

      this.appSetting.app3rdPartyTypeId = this.app3rdPartyType.app3rdPartyTypeId
      this.modalLoader = true

      if (this.isUpdate) {
        await this.$store.dispatch('patchAppThirdPartySettings', {
          appThirdPartyId: this.appSetting.app3rdPartyTypeId,
          data: this.appSetting,
        })
          // eslint-disable-next-line no-return-assign
          .then(() => { this.modalLoader = false; this.isUpdate = false; this.disableModal() })
          .catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
      } else {
        await this.$store.dispatch('postAppThirdPartySettings', this.appSetting)
          .then((resp) => this.addNewIntegration(resp.data.message))
          .catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
      }
    },
    async addNewIntegration (integration) {
      this.appSettings.splice(this.appSettings.length, -1, integration)
      this.disableModal()
    },
    showPromptModal (app3rdPartyId, index) {
      this.app3rdPartyIdInPrompt = app3rdPartyId
      this.indexInPrompt = index
      this.showRemoveModal = true
    },
    get3rdPartyDescription (name) {
      if (name === 'Twilio') {
        return this.$t('appSettings.integrations.smsGateway')
      } else if (name === 'Stripe') {
        return this.$t('appSettings.integrations.paymentProcessing')
      }
    },
    get3rdPartyTitle (name) {
      if (name === 'Twilio') {
        return this.$t('appSettings.integrations.sendSMS')
      } else if (name === 'Stripe') {
        return this.$t('appSettings.integrations.acceptPayments')
      }
    },
    async getThirdPartyTypes () {
      await this.$store.dispatch('getAppThirdPartyTypes')
        .then((resp) => this.initThirdPartyTypes(resp.data.message))
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    async initThirdPartyTypes (types) {
      this.app3rdPartyTypes.splice(0, this.app3rdPartyTypes.length, ...types)
      this.modalLoader = false
    },
    async initAppSettings (appSettings) {
      this.appSettings.splice(0, this.appSettings.length, ...appSettings)
      this.$store.commit('setLoading', false)
    },
    async createIntegration () {
      this.modalState = true
      this.modalLoader = true
      await this.getThirdPartyTypes()
    },
    removeIntegration (appThirdPartyId, index) {
      this.disabledDelete = true
      this.$store.dispatch('deleteAppThirdPartySettings', appThirdPartyId)
        .then(() => {
          this.appSettings.splice(index, 1)
          this.disabledDelete = false
          this.showRemoveModal = false
        })
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
          this.showRemoveModal = false
        })
    },
    async map3rdPartyType (appThirdParty) {
      return this.app3rdPartyTypes.filter((item) => {
        if (item.app3rdPartyTypeId === appThirdParty.app3rdPartyType.app3rdPartyTypeId) {}
        return item.app3rdPartyTypeId === appThirdParty.app3rdPartyType.app3rdPartyTypeId
      })
    },
    async updateIntegration (appThirdParty, index) {
      this.modalLoader = true
      await this.getThirdPartyTypes().then(() => this.map3rdPartyType(appThirdParty).then((resp) => {
        this.appSetting.secretKey = appThirdParty.secretKey
        this.appSetting.apiKey = appThirdParty.apiKey
        this.appSetting.infoKey = appThirdParty.infoKey
        this.app3rdPartyType = resp[0]
        // this.isUpdate = false
        this.modalState = true
      }))
      this.isUpdate = true
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getAppThirdPartySettings')
      .then((resp) => this.initAppSettings(resp.data.message))
      .catch(error => {
        this.errorHandler(error.response)
        this.modalLoader = false
      })
  },
  computed: {
    formConfigurationReady () {
      return !(this.appThirdPartyTypeError.length || this.secretKeyError.length || this.apiKeyError.length)
    },
  },
}
</script>

<style scoped>
  .va-item {
    min-width: auto;
  }
</style>
